/**
 * Types for Budget Assignment components
 */

import type { InvestmentItem } from "screens/investment/types/investment";

// Dialog state type
export type DialogStep = "units" | "source" | "distribution";
export type OverflowOption = "increase" | "new_line" | null;

// Unit distribution: { unitId: percentage }
export type UnitDistribution = Record<string, number>;

export interface DialogState {
  isOpen: boolean;
  step: DialogStep;
  unitIds: string[];
  labelFilter: number | null;
  matchingItems: InvestmentItem[];
  selectedItemId: number | null;
  isNewBudget: boolean;
  newBudgetLabelId: number | null;
  amount: number;
  overflowOption: OverflowOption;
  overflowReason: string;
  unitDistribution: UnitDistribution;
  // Audit trail: reason for creating new investment line
  creationReason: string;
  // Audit trail: reason for creating overflow line
  overflowCreationReason: string;
}

export const initialDialogState: DialogState = {
  isOpen: false,
  step: "units",
  unitIds: [],
  labelFilter: null,
  matchingItems: [],
  selectedItemId: null,
  isNewBudget: false,
  newBudgetLabelId: null,
  amount: 0,
  overflowOption: null,
  overflowReason: "",
  unitDistribution: {},
  creationReason: "",
  overflowCreationReason: "",
};

// Format currency helper
export const formatCurrency = (amount: number) =>
  new Intl.NumberFormat("nl-BE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
